import React from "react";
import DirectLayoutPDFGenerator from "./Reports/Direct_Layout";
import SiteReportPdfGenerator from "./Reports/Site_Report";
import {useCurrentUser} from "../../../../../../contexts/UserContext";
import {Flex} from "antd";
import {FilePdf} from "@phosphor-icons/react";
import MeasurePdfGenerator from "./Reports/Measure_Layout";

const ReportsSection : React.FC = () => {

    const {hasCapability} = useCurrentUser();


    return (
        <>
            <Flex justify={'left'} align={'center'} gap={5} className={"sidebar-headings"}> <FilePdf size={32}/>Reports</Flex>

            {hasCapability('Direct_Layout') && <DirectLayoutPDFGenerator/>}

            {hasCapability('Measure_Layout') && <MeasurePdfGenerator/>}

            {(hasCapability('oneDRAW_Site_Report') || hasCapability('Genesis_Site_Report')) && <SiteReportPdfGenerator/>}

        </>

    )
}

export default ReportsSection